<template>
    <div class="text-center mt-4">
      <img src="/img/preloader.gif" alt="Loading..." />
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoadingSpinner',
  };
  </script>
  
  <style scoped>
  </style>